module.exports = __webpack_public_path__ + "resources/img/GitHub-Mark-120px-plus.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/GitHub-Mark-120px-plus.png
// module id = 1106
// module chunks = 0